module.exports = __webpack_public_path__ + "static/media/human.91d830ef.svg";